import styled from "styled-components";

export const Container1 = styled.div`
    padding: 5rem 5rem;
    height: fit-content;
    @media screen and (max-width: 414px) {
        padding: 3rem 3rem;
    }
`

export const Container2 = styled.div`
    width: 100%;
    max-width: 1040px;
    margin: 0 auto;

    p {
        margin-bottom: 20px;
    }

    ol {
        font-weight: bold;
        margin-left: 20px;
    }
`;
